/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboGetintegrationsIntegrationResponse
 */
export interface JumboGetintegrationsIntegrationResponse {
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof JumboGetintegrationsIntegrationResponse
     */
    featureScopeMap?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {boolean}
     * @memberof JumboGetintegrationsIntegrationResponse
     */
    isConfigured?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JumboGetintegrationsIntegrationResponse
     */
    isConnected?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JumboGetintegrationsIntegrationResponse
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof JumboGetintegrationsIntegrationResponse
     */
    scopes?: Array<string>;
}

/**
 * Check if a given object implements the JumboGetintegrationsIntegrationResponse interface.
 */
export function instanceOfJumboGetintegrationsIntegrationResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGetintegrationsIntegrationResponseFromJSON(json: any): JumboGetintegrationsIntegrationResponse {
    return JumboGetintegrationsIntegrationResponseFromJSONTyped(json, false);
}

export function JumboGetintegrationsIntegrationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetintegrationsIntegrationResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'featureScopeMap': !exists(json, 'featureScopeMap') ? undefined : json['featureScopeMap'],
        'isConfigured': !exists(json, 'isConfigured') ? undefined : json['isConfigured'],
        'isConnected': !exists(json, 'isConnected') ? undefined : json['isConnected'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'scopes': !exists(json, 'scopes') ? undefined : json['scopes'],
    };
}

export function JumboGetintegrationsIntegrationResponseToJSON(value?: JumboGetintegrationsIntegrationResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'featureScopeMap': value.featureScopeMap,
        'isConfigured': value.isConfigured,
        'isConnected': value.isConnected,
        'isEnabled': value.isEnabled,
        'scopes': value.scopes,
    };
}

